import $ from 'jquery';

export default class DynamicFaq {
  constructor(section) {
    this.toggles = $('[data-faq-toggle]', section.el);
    this.toggles.on('click', event => this._onClick(event));
    this.toggles.on('keydown', event => this._onKeydown(event));
  }

  _onClick(event) {
    this._onToggle(event);
  }

  _onKeydown(event) {
    if (event.key === 'Enter') {
      this._onToggle(event);
    }
  }

  _onToggle(event) {
    $(event.currentTarget).toggleClass('active');
    $(event.currentTarget).next().stop().slideToggle(150);
  }

  onSectionUnload() {
    this.toggles.off('click');
    this.toggles.off('keydown');
  }

  onSectionBlockSelect(block) {
    const $trigger = $(block.el);

    if (!$trigger.hasClass('active')) {
      $trigger.trigger('click');
    }
  }
}
